<template>
  <div class="vehicle-anomaly-record">
    <el-row class="condition">
      <el-form size="small" :inline="true" class="vehicle-anomaly-form">
        <el-form-item label="车牌号：">
          <el-input v-model="queryParam.vehicleNo" clearable placeholder="模糊查询" style="width: 140px" />
        </el-form-item>
        <el-form-item label="司机编号：">
          <el-input v-model="queryParam.driverNo" clearable placeholder="司机编号" style="width: 120px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryList(1)">查询</el-button>
        </el-form-item>
        <el-form-item class="operate-item">
          <el-button type="primary" plain icon="el-icon-plus" @click="openDialog()">车辆异常上报</el-button>
          <el-button type="warning" plain icon="el-icon-edit-outline" @click="openTireRemarkDialog">
            轮胎异常上报
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div class="table">
      <el-table :data="list" stripe max-height="520">
        <el-table-column label="序号" type="index" width="50" />
        <el-table-column prop="vehicleNo" label="车牌号" width="100" />
        <el-table-column prop="driverNo" label="司机编号" width="100" />
        <el-table-column prop="driverName" label="司机姓名" width="100" show-overflow-tooltip />
        <el-table-column prop="eventDate" label="事件日期" width="110" />
        <el-table-column prop="eventLabel" label="事件标签" width="120" show-overflow-tooltip />
        <el-table-column prop="eventDesc" label="事件描述" min-width="160" show-overflow-tooltip />
        <el-table-column prop="reporter" label="上报者" width="90" show-overflow-tooltip />
        <el-table-column label="图片" width="80" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.eventPhotos && scope.row.eventPhotos.length">
              <el-image v-if="firstPhotoUrl(scope.row.eventPhotos)"
                style="width: 40px; height: 40px; vertical-align: middle" :src="firstPhotoUrl(scope.row.eventPhotos)"
                :preview-src-list="photoList(scope.row.eventPhotos)" fit="cover" />
              <span v-else>有</span>
            </template>
            <span v-else class="text-placeholder">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat("yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
            <el-button type="text" size="small" class="danger-text" @click="removeRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination background :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" @current-change="handlePageChange" />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" append-to-body @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="司机" prop="driverId">
          <el-select v-model="form.driverId" filterable placeholder="请选择司机" style="width: 100%" :loading="driverLoading"
            @change="onDriverChange">
            <el-option v-for="d in driverOptions" :key="d.id" :label="driverOptionLabel(d)" :value="d.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="车辆" prop="vehicleId">
          <el-select v-model="form.vehicleId" filterable placeholder="请选择车辆" style="width: 100%"
            :loading="vehicleLoading">
            <el-option v-for="v in vehicleOptions" :key="v.id" :label="v.vehicleNo" :value="v.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="事件日期" prop="eventDate">
          <el-date-picker v-model="form.eventDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
            style="width: 100%" />
        </el-form-item>
        <el-form-item label="事件标签" prop="eventLabel">
          <el-input v-model="form.eventLabel" maxlength="128" show-word-limit placeholder="选填" />
        </el-form-item>
        <el-form-item label="事件描述" prop="eventDesc">
          <el-input v-model="form.eventDesc" type="textarea" :rows="4" placeholder="必填" />
        </el-form-item>
        <el-form-item label="上报者" prop="reporter">
          <el-input v-model="form.reporter" />
        </el-form-item>
        <el-form-item label="图片">
          <multiple-file-upload v-model="form.eventPhotos" :simpleData="true" :limit="6" filePath="/vehicle/anomaly"
            uploadTip="支持多文件上传，最多6张（每张不超过20MB）" />
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="submitForm">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 轮胎异常上报 -->
    <el-dialog title="轮胎异常上报" :visible.sync="tireRemarkVisible" width="520px" append-to-body>
      <el-form :model="tireRemarkForm" label-width="90px" size="small">
        <el-form-item label="车辆">
          <el-select v-model="tireRemarkForm.vehicleId" filterable placeholder="请选择车辆" style="width: 100%">
            <el-option v-for="v in vehicleOptions" :key="v.id" :label="v.vehicleNo" :value="v.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="轮位">
          <el-select v-model="tireRemarkForm.position" placeholder="请选择轮位" style="width: 100%">
            <el-option v-for="p in positionOpts" :key="p.value" :label="p.label" :value="p.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="异常描述">
          <el-input v-model="tireRemarkForm.remark" type="textarea" :rows="3" placeholder="请简要描述轮胎异常情况" />
        </el-form-item>
        <el-form-item label="图片">
          <multiple-file-upload v-model="tireRemarkForm.photos" :simpleData="true" :limit="6"
            filePath="/vehicle/tire_remark" uploadTip="可上传轮胎异常照片（最多6张，每张不超过20MB）" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tireRemarkVisible = false">取 消</el-button>
        <el-button type="primary" :loading="tireRemarkLoading" @click="submitTireRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ParamUtil } from "@/util";
import {
  getDriverList,
  listVehicle,
  pageVehicleAnomalyRecord,
  saveVehicleAnomalyRecord,
  deleteVehicleAnomalyRecord,
  addTireOpRemark
} from "@/api";

function emptyForm() {
  return {
    id: null,
    vehicleId: null,
    driverId: null,
    eventDate: "",
    eventDesc: "",
    eventLabel: "",
    reporter: "",
    eventPhotos: []
  };
}

export default {
  name: "VehicleAnomalyRecord",
  data() {
    return {
      queryParam: {
        vehicleNo: "",
        driverNo: ""
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dialogVisible: false,
      dialogTitle: "新增异常记录",
      form: emptyForm(),
      rules: {
        vehicleId: [{ required: true, message: "请选择车辆", trigger: "change" }],
        driverId: [{ required: true, message: "请选择司机", trigger: "change" }],
        eventDesc: [{ required: true, message: "请填写事件描述", trigger: "blur" }]
      },
      vehicleOptions: [],
      driverOptions: [],
      vehicleLoading: false,
      driverLoading: false,
      saveLoading: false,
      suspendDriverChange: false,

      // 轮胎异常上报弹窗
      tireRemarkVisible: false,
      tireRemarkForm: {
        vehicleId: null,
        position: "",
        remark: "",
        photos: []
      },
      tireRemarkLoading: false,
      positionOpts: [
        { label: "左前", value: "左前" },
        { label: "右前", value: "右前" },
        { label: "左后", value: "左后" },
        { label: "右后", value: "右后" }
      ]
    };
  },
  created() {
    this.loadVehicleOptions();
    this.loadDriverOptions();
    this.queryList(1);
  },
  methods: {
    driverOptionLabel(d) {
      if (!d) return "";
      const no = d.no || "";
      const name = d.name || "";
      return no ? `${name}（${no}）` : name;
    },
    loadVehicleOptions() {
      this.vehicleLoading = true;
      listVehicle({
        page: { current: 1, size: 800 },
        param: { status: "ACTIVE" }
      })
        .then((res) => {
          const data = res.data || {};
          this.vehicleOptions = data.records || [];
        })
        .finally(() => {
          this.vehicleLoading = false;
        });
    },
    loadDriverOptions() {
      this.driverLoading = true;
      getDriverList({
        page: { current: 1, size: 2000 },
        param: {}
      })
        .then((res) => {
          const data = res.data || {};
          this.driverOptions = data.records || [];
        })
        .finally(() => {
          this.driverLoading = false;
        });
    },
    openTireRemarkDialog() {
      // 默认带当前查询条件中的车牌，若车辆下拉已加载则尝试预选
      const vehicleNo = (this.queryParam.vehicleNo || "").trim();
      let vehicleId = null;
      if (vehicleNo && this.vehicleOptions && this.vehicleOptions.length) {
        const found = this.vehicleOptions.find((v) => v.vehicleNo === vehicleNo);
        if (found) vehicleId = found.id;
      }
      this.tireRemarkForm = {
        vehicleId,
        position: "",
        remark: "",
        photos: []
      };
      this.tireRemarkVisible = true;
    },
    firstPhotoUrl(photos) {
      if (!Array.isArray(photos) || photos.length === 0) return "";
      const urls = photos.map((s) => (s || "").toString().trim()).filter(Boolean);
      return urls[0] || "";
    },
    photoList(photos) {
      if (!Array.isArray(photos) || photos.length === 0) return [];
      return photos.map((s) => (s || "").toString().trim()).filter(Boolean);
    },
    queryList(page = 1) {
      const param = {
        page: { current: page, size: this.pageSize },
        param: ParamUtil.filterEmptyData(this.queryParam)
      };
      pageVehicleAnomalyRecord(param).then((res) => {
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total || 0;
        this.currentPage = data.current || 1;
      });
    },
    handlePageChange(page) {
      this.queryList(page);
    },
    openDialog(row) {
      this.suspendDriverChange = true;
      if (row) {
        this.dialogTitle = "编辑异常记录";
        this.form = {
          id: row.id,
          vehicleId: row.vehicleId,
          driverId: row.driverId,
          eventDate: row.eventDate || "",
          eventDesc: row.eventDesc || "",
          eventLabel: row.eventLabel || "",
          reporter: row.reporter || "",
          eventPhotos: row.eventPhotos || []
        };
      } else {
        this.dialogTitle = "新增异常记录";
        this.form = emptyForm();
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
        this.suspendDriverChange = false;
      });
    },
    onDriverChange(driverId) {
      if (this.suspendDriverChange) return;
      if (!driverId) {
        this.form.vehicleId = null;
        return;
      }
      const driver = (this.driverOptions || []).find((d) => String(d.id) === String(driverId));
      const vehicleId = driver ? driver.vehicleId : null;
      this.form.vehicleId = vehicleId || null;
    },
    onDialogClosed() {
      this.form = emptyForm();
    },
    submitForm() {
      this.$refs.formRef.validate((ok) => {
        if (!ok) return;
        this.saveLoading = true;
        const payload = {
          id: this.form.id,
          vehicleId: this.form.vehicleId,
          driverId: this.form.driverId,
          eventDate: this.form.eventDate || null,
          eventDesc: this.form.eventDesc,
          eventLabel: this.form.eventLabel || undefined,
          reporter: this.form.reporter || undefined,
          eventPhotos: Array.isArray(this.form.eventPhotos) ? this.form.eventPhotos : []
        };
        saveVehicleAnomalyRecord(payload)
          .then(() => {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.queryList(this.currentPage);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    submitTireRemark() {
      if (!this.tireRemarkForm.vehicleId) {
        this.$message.warning("请先选择车辆");
        return;
      }
      if (!this.tireRemarkForm.position) {
        this.$message.warning("请选择轮位");
        return;
      }
      this.tireRemarkLoading = true;
      const payload = {
        vehicleId: this.tireRemarkForm.vehicleId,
        position: this.tireRemarkForm.position,
        remark: this.tireRemarkForm.remark || undefined,
        photos: Array.isArray(this.tireRemarkForm.photos) ? this.tireRemarkForm.photos : undefined
      };
      addTireOpRemark(payload)
        .then(() => {
          this.$message.success("轮胎异常上报成功");
          this.tireRemarkVisible = false;
          this.queryList(1);
        })
        .finally(() => {
          this.tireRemarkLoading = false;
        });
    },
    removeRow(row) {
      this.$confirm("确认删除该条异常记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteVehicleAnomalyRecord(row.id).then(() => {
          this.$message.success("已删除");
          this.queryList(this.currentPage);
        });
      });
    }
  }
};
</script>

<style scoped>
.vehicle-anomaly-record .condition {
  margin-bottom: 12px;
}

.vehicle-anomaly-form {
  display: flex;
  align-items: center;
}

.vehicle-anomaly-form .operate-item {
  margin-left: auto;
}

.vehicle-anomaly-record .page {
  margin-top: 12px;
  text-align: right;
}

.text-placeholder {
  color: #c0c4cc;
}

.danger-text {
  color: #f56c6c;
}
</style>
